import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { TIER_LABELS } from "@/data/options";

// Read-only tier-grouped carrier listing with edit/delete actions.
export const CarrierList = ({ carriers, onEdit, onDelete }) => (
  <div className="overflow-auto flex-1 -mx-6 px-6">
    {[1, 2, 3, 0].map((tier) => {
      const list = carriers.filter((c) => c.tier === tier);
      if (!list.length) return null;
      return (
        <div key={tier} className="mt-4">
          <h4 className="text-xs font-bold uppercase tracking-wide text-[#F97316] mb-2">
            {TIER_LABELS[tier]}
          </h4>
          <div className="space-y-1">
            {list.map((c) => (
              <div
                key={c.id}
                className={`flex items-center justify-between gap-2 py-2 px-3 rounded-md border ${
                  c.disabled ? "border-red-200 bg-red-50" : "border-border"
                }`}
                data-testid={`carrier-row-${c.id}`}
              >
                <div className="min-w-0">
                  <div className="text-sm font-medium text-[#1C1917] truncate">
                    {c.preferred && <span className="text-[#F97316]" title="Preferred">★ </span>}
                    {c.name} {c.location ? <span className="text-[#57534E] font-normal">— {c.location}</span> : null}
                  </div>
                  {c.notes && <div className="text-xs text-[#57534E] truncate">{c.notes}</div>}
                  {(c.contacts?.length || c.email) && (
                    <div className="text-xs text-[#EA580C] truncate" data-testid={`carrier-email-${c.id}`}>
                      {c.contacts?.length
                        ? c.contacts.map((ct) => ct.name?.trim() || ct.email).filter(Boolean).join(", ")
                        : c.email}
                    </div>
                  )}
                </div>
                <div className="flex gap-1 shrink-0">
                  <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onEdit(c)} data-testid={`carrier-edit-${c.id}`}>
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-red-600" onClick={() => onDelete(c.id)} data-testid={`carrier-delete-${c.id}`}>
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    })}
  </div>
);
